const COST_MANAGEMENT_PRINCIPAL_ID = "00000000-0000-0000-1000-000000000001";

export default {
  name: "LlmOverview",
  data: () => ({}),
  async mounted() {
    await this.$store.dispatch("getLLMConfig");
    await this.$store.dispatch("getLLMApiKeys");
  },
  computed: {
    currentUser() {
      return this.$store.state.currentUser;
    },
    isAdmin() {
      return this.currentUser?.scopes?.includes("role:admin");
    },
    isPromptAdmin() {
      return (
        this.isAdmin || this.currentUser?.scopes?.includes("role:prompt_admin")
      );
    },
    selectedPrincipalId() {
      return this.$store.state.selectedPrincipal?.id || "";
    },
    canAccessCostManagement() {
      return this.selectedPrincipalId === COST_MANAGEMENT_PRINCIPAL_ID;
    }
  },
  methods: {
    goTo(path) {
      this.$router.push(path);
    }
  }
};
